package es.subastia.domain.model

data class SavedSearchModel(
    val id: String = "",
    val userId: String,
    val title: String? = null,
    val type: AuctionTypeDomainModel? = null,
    val procedureType: AuctionProcedureType? = null,
    val province: ProvinceDomainModel? = null,
    val query: String? = null,
    val createdAt: Long = 0L
)
